import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_PURCHASE_INVOICE,
   GET_PURCHASE_INVOICE,
   GET_PURCHASE_INVOICES,
   GET_PURCHASE_INVOICES_TRANSACTIONS,
   UPDATE_PURCHASE_INVOICE,
   DELETE_PURCHASE_INVOICE,
   DELETE_MULTI_PURCHASE_INVOICE,
   LAST_BILL_PURCHASE_INVOICE,
   GET_LAST_PURCHASE_DAYBOOK,
   GET_PURCHASE_LINE_ITEMS,
   ADD_PURCHASE_LINE_ITEM,
   UPDATE_PURCHASE_LINE_ITEM,
   DELETE_PURCHASE_LINE_ITEM,
   GET_ONE_PURCHASE_INVOICE,
   EMPTY_ONE_PURCHASE_INVOICE,
   GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT,
   GET_PURCHASE_INVOICE_PREV_AND_NEXT,
   GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT,
   UPDATE_SYNC_PURCHASE_INVOICE,
   GRAY_PURCHASE_PENDING_ISSUE,
   GET_PURCHASE_INVOICES_FOR_DAYBOOK,
   GET_PURCHASE_DOC_PDF,
   UPDATE_PURCHASE_DOC,
   DELETE_PURCHASE_DOC,
   IMPORT_PURCHASE_EXCEL,
} from '../types';
import { data } from 'autoprefixer';

// Add Purchase Invoice
export const addPurchaseInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-invoice/add`, formData);

      if (res.data.code === 1) {
         dispatch({
            type: ADD_PURCHASE_INVOICE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         //  navigate('/admin/purchase/invoice');
         setTimeout(() => {
            toast.success('Purchase Invoice added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data?.message);
         return err.response?.data;
      } else {
         if (err?.response?.data?.errors[0]?.message) {
            toast.error(err?.response?.data?.errors[0]?.message);
         } else {
            toast.error(err);
         }
      }
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-invoice/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

export const importFromGst = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-invoice/importFromGst', data);
      if (res.data.code === 1) {
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// Get getPurchaseInvoice
export const getPurchaseInvoices = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_INVOICES,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (err) {
      console.error('getPurchaseInvoices err', err);
   }
};

export const getPurchaseInvoicesForDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_INVOICES_FOR_DAYBOOK,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (err) {
      console.error('getPurchaseInvoices err', err);
   }
};

export const getPurchaseInvoicestransactions = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_INVOICES_TRANSACTIONS,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (err) {
      console.error('getPurchaseInvoices err', err);
   }
};

// Get Single PurchaseInvoice
export const getPurchaseInvoice = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-invoice/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_INVOICE,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
         return res.data;
      }
   } catch (err) {
      console.error('getPurchaseInvoice err', err);
   }
};

export const importPurchaseExcel = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-invoice/importFromExcel', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: IMPORT_PURCHASE_EXCEL, payload: res.data.data });
         setTimeout(() => {
            toast.success(`
               Total Invoice: ${res.data.data?.totalInvoiceGroups || 0},   
               Successfully Added: ${res.data.data?.successfulInvoices || 0},   
               Failed: ${res.data.data?.failedInvoices || 0},
               Total Rows: ${res.data.data?.totalRows || 0}
            `);
         }, 0);
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      return { code: 0, message: 'API request failed' };
   }
};

// Get Last Purchase Daybook
export const getLastPurchaseDaybook = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/purchase/last`, { params });
      const res = await axios.get(`/purchase-invoice/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_PURCHASE_DAYBOOK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.error('getLastPurchaseDaybook err', err);
   }
};

// Update PurchaseInvoice
export const updatePurchaseInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-invoice/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PURCHASE_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Invoice updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data?.message);
         return err.response?.data;
      } else {
         if (err?.response?.message) {
            toast.error(err?.response?.message);
         } else {
            toast.error(err);
         }
      }
      return err.response?.data;
   }
};

export const updateSyncPurchaseInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase/update/sync-data/status`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SYNC_PURCHASE_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Invoice updated successfully!');
         }, 1000);
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data?.message);
         return err.response?.data;
      } else {
         if (err?.response?.data?.message) {
            toast.error(err?.response?.data?.message);
         } else {
            toast.error(err);
         }
      }
   }
};

// Last Bill Purchase Invoice
export const lastBillPurchaseInvoice = (params) => async (dispatch) => {
   try {
      // if (!id) {
      //   toast.warn('Please select any record', 'warning');
      //   return false;
      // }
      const res = await axios.get(`/purchase/last-billNo`, { params }); //pass Daybook ID
      if (res.data.code === 1) {
         dispatch({
            type: LAST_BILL_PURCHASE_INVOICE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
// Delete Purchase Invoice
export const deleteMultiPurchaseInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post('/purchase-invoice/delete/multi', formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_PURCHASE_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Invoice deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const deletePurchaseInvoice =
   (id, outAdjustmentIds = null) =>
      async (dispatch) => {
         try {
            if (!id) {
               toast.warn('Please select any record', 'warning');
               return false;
            }

            dispatch({ type: 'SET_LOADING', payload: true });

            let res;

            // If outAdjustmentIds are provided, send them in the request body
            if (outAdjustmentIds && outAdjustmentIds.length > 0) {
               // Send outAdjustmentIds in request body
               res = await axios.post(`/purchase-invoice/delete/${id}`, {
                  outAdjustmentIds: outAdjustmentIds,
               });
            } else {
               // Normal deletion without body data
               res = await axios.post(`/purchase-invoice/delete/${id}`);
            }

            dispatch({ type: 'SET_LOADING', payload: false });

            if (res.data.code === 1) {
               dispatch({ type: DELETE_PURCHASE_INVOICE, payload: { id } });
               setTimeout(() => {
                  toast.success(res.data.message);
               }, 1000);
            }

            if (res.data.code === 2) {
               setTimeout(() => {
                  toast.warn(res.data.message);
               }, 1000);
            }
         } catch (err) {
            dispatch({ type: 'SET_LOADING', payload: false });
            if (err.response?.data?.message) {
               toast.error(err.response?.data?.message);
            }
         }
      };

export const deleteSyncCode =
   (id, outAdjustmentIds = null) =>
      async (dispatch) => {
         try {
            if (!id) {
               toast.warn('Please select any record', 'warning');
               return false;
            }

            dispatch({ type: 'SET_LOADING', payload: true });

            let res;

            // If outAdjustmentIds are provided, send them in the request body
            if (outAdjustmentIds && outAdjustmentIds.length > 0) {
               // Send outAdjustmentIds in request body
               res = await axios.post(`/purchase-invoice/syncDelete/${id}`, {
                  outAdjustmentIds: outAdjustmentIds,
               });
            } else {
               // Normal deletion without body data
               res = await axios.post(`/purchase-invoice/syncDelete/${id}`);
            }

            dispatch({ type: 'SET_LOADING', payload: false });

            if (res.data.code === 1) {
               dispatch({ type: DELETE_PURCHASE_INVOICE, payload: { id } });
               setTimeout(() => {
                  toast.success(res.data.message);
               }, 1000);
            }

            if (res.data.code === 2) {
               setTimeout(() => {
                  toast.warn(res.data.message);
               }, 1000);
            }
         } catch (err) {
            dispatch({ type: 'SET_LOADING', payload: false });
            if (err.response?.data?.message) {
               toast.error(err.response?.data?.message);
            }
         }
      };

export const getPurchaseLineItems = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/purchaseLineItem/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_PURCHASE_LINE_ITEMS, payload: res.data.data });
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      // console.error("Failed to get Size. Please try again. :", err);
   }
};

export const addPurchaseLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/purchaseLineItem/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_PURCHASE_LINE_ITEM, payload: res.data.data });
         setTimeout(() => {
            toast.success('SalesLineItem added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response.data?.message);
      }
   }
};

export const updatePurchaseLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/purchaseLineItem/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PURCHASE_LINE_ITEM, payload: res.data.data });

         setTimeout(() => {
            toast.success('SalesLineItem updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response.data?.message);
      }
      // toast.error("Failed to update Size. Please try again.");
   }
};

export const deletePurchaseLineItem = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/purchaseLineItem/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_LINE_ITEM, payload: { id } });
         setTimeout(() => {
            toast.success('SalesLineItem deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response.data?.message);
      }
      // toast.error("Failed to delete Size. Please try again.");
   }
};

export const getPurchaseLineItem = (id) => async (dispatch) => {
   const res = await axios.get(`/purchaseLineItem/${id}`);
   if (res.data.code === 1) {
      dispatch({ type: GET_PURCHASE_LINE_ITEMS, payload: res.data.data });
   }
   return res.data.code;
};

export const getSinglePurchaseInvoice = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchase-invoice/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_PURCHASE_INVOICE, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getSinglePurchaseWithPrevAndNext = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT,
            payload: res.data,
            // payload: res.data.data,
            // totalCount: res.data.totalCount,
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const getPrevAndNext = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchase-invoice/prev-next`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_PURCHASE_INVOICE_PREV_AND_NEXT, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const emptyPurchase = () => async (dispatch) => {
   console.log('reset...');
   dispatch({ type: EMPTY_ONE_PURCHASE_INVOICE, payload: null });
};

export const getPendingVoucherPurchaseAdjustment = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/unadjusted/pending-voucher-with-purchase-adjustments`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT,
            payload: res.data.data,
         });
      }
   } catch (error) {
      console.error(error);
   } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
   }
};

export const getGrayPurchasePendingIssue = (params) => async (dispatch) => {
   try {
      console.log('params123', params);
      const res = await axios.get(`/purchase-invoice/gray-challan-pending-issue`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GRAY_PURCHASE_PENDING_ISSUE, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getPurchaseDocPdf = (payload) => async (dispatch) => {
   try {
      const res = await axios.post(`/purchase-invoice/getDocPdf`, payload, {
         // Remove the params wrapper
         responseType: 'arraybuffer', // Add this for PDF binary data
      });

      console.log('API Response:', res);
      console.log('Response data type:', typeof res.data);
      console.log('Response is ArrayBuffer:', res.data instanceof ArrayBuffer);

      // Return the binary data directly
      return {
         code: 1,
         pdfBuffer: res.data,
         message: 'PDF retrieved successfully',
      };
   } catch (err) {
      console.error('Failed to get PDF:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Download failed';
      toast.error(errorMessage);
      throw err;
   }
};

export const uploadPurchaseDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-invoice/addImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PURCHASE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deletePurchaseDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-invoice/deleteImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
